import { render } from "./Depreciation_history_asset_wise.vue?vue&type=template&id=d6044d6a&scoped=true"
import script from "./Depreciation_history_asset_wise.vue?vue&type=script&lang=js"
export * from "./Depreciation_history_asset_wise.vue?vue&type=script&lang=js"

import "./Depreciation_history_asset_wise.vue?vue&type=style&index=0&id=d6044d6a&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6044d6a"]])

export default __exports__